import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { InvoiceDeliveryLog, InvoiceDeliveryLogCreate, InvoiceDeliveryLogFilter } from '../data/invoiceDeliveryLog';

export function createInvoiceDeliveryLogService(client: AxiosInstance) {
  return createCrudService<InvoiceDeliveryLog, InvoiceDeliveryLogCreate, InvoiceDeliveryLogFilter>(
    client,
    '/accounting/InvoiceDeliveryLog',
    'id',
  );
}

export type InvoiceDeliveryLogService = CrudService<InvoiceDeliveryLog, InvoiceDeliveryLogCreate, InvoiceDeliveryLogFilter>;
